import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
    const url = config.url || "";
    const admin = localStorage.getItem("admin_token");
    const owner = localStorage.getItem("owner_token");
    const token = url.startsWith("/owner") ? owner : url.startsWith("/admin") ? admin || owner : null;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function errorText(e, fallback) {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
    return fallback;
}

export default api;
